import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Logo } from '@/components/Logo';
import { clearSession } from '@/features/auth/session';
import { t } from '@/lib/strings';

/**
 * The frame around the sales flow. The report page deliberately does not use it: a customer
 * opening their link should see a report, not an application.
 */
export function AppShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const onAdmin = location.pathname.startsWith('/admin');

  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      {/* Keyboard users should not have to tab through the header on every screen. */}
      <Box
        component="a"
        href="#indhold"
        sx={{
          position: 'absolute',
          left: -9999,
          top: 8,
          zIndex: 10,
          p: 1.5,
          borderRadius: 1,
          backgroundColor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          '&:focus': { left: 8 },
        }}
      >
        {t('navigation.springTilIndhold')}
      </Box>

      <AppBar
        component="nav"
        position="sticky"
        color="default"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Toolbar sx={{ gap: 2 }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              textDecoration: 'none',
              color: 'text.primary',
              flexGrow: 1,
            }}
          >
            {/* Decorative: the application title sits right beside it, so announcing the logo
                too would read the brand out twice. */}
            <Logo height={28} decorative />
            <Typography component="span" variant="h3">
              {t('app.titel')}
            </Typography>
          </Box>

          <Button component={RouterLink} to={onAdmin ? '/' : '/admin'} size="small">
            {onAdmin ? t('handling.nyVurdering') : t('admin.overskrift')}
          </Button>

          <Button
            size="small"
            color="inherit"
            onClick={() => {
              clearSession();
              navigate('/login', { replace: true });
            }}
          >
            {t('handling.logUd')}
          </Button>
        </Toolbar>
      </AppBar>

      <Container
        id="indhold"
        component="main"
        maxWidth="lg"
        sx={{ flexGrow: 1, py: { xs: 3, md: 5 } }}
      >
        <Outlet />
      </Container>
    </Box>
  );
}
